// Personal goals (PersonalGoalsView.vue and its modals; API routes/personalgoals.ts)

export const CATEGORIES = [
    { value: 'career', label: 'Career' },
    { value: 'skill', label: 'Skill' },
    { value: 'leadership', label: 'Leadership' },
    { value: 'health', label: 'Health' },
    { value: 'family', label: 'Family' },
    { value: 'money', label: 'Money' },
    { value: 'other', label: 'Other' }
];

export const VISIBILITIES = [
    { value: 'private', label: 'Only Me' },
    { value: 'manager', label: 'Me and My Manager' },
    { value: 'team', label: 'My Team' }
];

export const TRACK_TYPES = [
    { value: 'steps', label: 'Steps' },
    { value: 'number', label: 'A Number' },
    { value: 'yesno', label: 'Done / Not' }
];

export const STATUSES = [
    { value: 'on', label: 'On Track', cls: 'ok' },
    { value: 'off', label: 'Behind', cls: 'bad' },
    { value: 'done', label: 'Done', cls: 'done' }
];

export function categoryLabel(value: string): string {
    return (CATEGORIES.find(c => c.value == value) || CATEGORIES[CATEGORIES.length - 1]).label;
}

export function statusInfo(value: string): { label: string, cls: string } {
    return STATUSES.find(s => s.value == value) || STATUSES[0];
}

function pad(n: number): string {
    return String(n).padStart(2, '0');
}

export function isoDate(d: Date): string {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function addDays(date: string, days: number): string {
    const d = new Date(date + 'T00:00:00');
    d.setDate(d.getDate() + days);
    return isoDate(d);
}

// Whole days from a to b ("YYYY-MM-DD"); negative when b is earlier
export function daysBetween(a: string, b: string): number {
    return Math.round((new Date(b + 'T00:00:00').getTime() - new Date(a + 'T00:00:00').getTime()) / 86400000);
}

const MONTHS = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];

// "Oct 8", or "Oct 8, 2027" outside this year
export function dateLabel(date: string): string {
    const d = new Date(date + 'T00:00:00');
    return `${MONTHS[d.getMonth()]} ${d.getDate()}` + (d.getFullYear() != new Date().getFullYear() ? `, ${d.getFullYear()}` : '');
}

// "12" or "12.5", without float noise
export function formatNumber(n: any): string {
    return n === null || n === undefined || n === '' ? '' : String(Math.round(Number(n) * 100) / 100);
}
